import { render } from "./addCardAndEditCard.vue?vue&type=template&id=651d0022&scoped=true"
import script from "./addCardAndEditCard.vue?vue&type=script&lang=js"
export * from "./addCardAndEditCard.vue?vue&type=script&lang=js"

import "./addCardAndEditCard.vue?vue&type=style&index=0&id=651d0022&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651d0022"]])

export default __exports__